/**
 * 통계 카드 컴포넌트
 */

import React from 'react';
import { Card } from 'react-bootstrap';
import './StatCard.css';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

const StatCard: React.FC<StatCardProps> = ({ title, value, subtitle, icon, trend }) => {
  const formatValue = (val: string | number): string => {
    if (typeof val === 'number') {
      if (val >= 1000000) {
        return `₩${(val / 1000000).toFixed(1)}M`;
      } else if (val >= 1000) {
        return `₩${(val / 1000).toFixed(0)}K`;
      }
      return `₩${val.toLocaleString()}`;
    }
    return val;
  };

  return (
    <Card className="stat-card">
      <Card.Body>
        <div className="stat-card-header">
          <div className="stat-card-title">{title}</div>
          {icon && <div className="stat-card-icon">{icon}</div>}
        </div>
        <div className="stat-card-value">{formatValue(value)}</div>
        {subtitle && <div className="stat-card-subtitle">{subtitle}</div>}
        {trend && (
          <div className={`stat-card-trend ${trend.isPositive ? 'positive' : 'negative'}`}>
            {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default StatCard;

